class ProductBuyOptions extends HTMLElement {
    constructor() {
        super();

        this.bundleProductSelector = this.querySelector('.bundle-product-selector')
        this.bundleOptionSelectors = this.querySelectorAll('.bundle-option-selector')
        this.bundleGroupSelectors = this.querySelectorAll('.bundle-group-selector')
        this.variantFixedSetSelectors = this.querySelectorAll('.variant-fixed-set-selector')
        this.variantSetSelectors = this.querySelectorAll('.variant-set-selector')
        this.bundleGroupedSetSelectors = this.querySelectorAll('.bundle-grouped-set-selector')
        this.bundleSetSelectors = this.querySelectorAll('.bundle-set-selector')
        this.idElement = this.querySelector('input[name="id"]')
        this.qtyElement = this.querySelector('.js-productInfoQty')
        this.productSelectorToggleValue = this.querySelector('#pdp-variant-selector-toggle .option-selector__toggle__color')
        this.productSelectorToggleSwatch = this.querySelector('#pdp-variant-selector-toggle .option-selector__swatch')
        this.productGallery = document.querySelector('.product-gallery.js-productGallery')
        this.productImagePicture = document.querySelector('.product-details-top__image__wrapper picture')
        this.productName = document.querySelector('.product-details-top__name')
        this.form = this.querySelector('form')
        this.button = this.querySelector('.product-buy-options__add-wrapper > button')
        this.buyOptions = this.querySelector('.product-buy-options__add-wrapper')
        this.minCharmPrice = this.querySelector('.js-minCharmPrice') ? parseFloat(this.querySelector('.js-minCharmPrice').value) : 0
        this.options = {}
    }

    connectedCallback() {
//        console.log('product-buy-options connected')
        // console.log(this.bundleProductSelector)
        this.variantFixedSetSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.addEventListener('click', this.variantFixedSetClick.bind(this))
            })
        })
        this.variantSetSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.addEventListener('click', this.variantSetClick.bind(this))
            })
        })
        this.bundleProductSelector?.querySelectorAll('.option-selector__variant')?.forEach((selector)=>{
            selector.addEventListener('click', this.productSelectorClick.bind(this))
        })
        this.bundleOptionSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.addEventListener('click', this.optionSelectorClick.bind(this))
            })
            selector.querySelectorAll('.remove')?.forEach((variantSelectorRemove)=>{
                variantSelectorRemove.addEventListener('click', this.optionSelectorRemoveClick.bind(this))
            })
            selector.querySelector('.option-selector__variant:has(.is-current)')?.click()
        })
        this.bundleGroupSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.addEventListener('click', this.groupSelectorClick.bind(this))
            })
            if(selector.dataset.mandatory == 'true') {
                // selector.querySelector('.option-selector__variant').click()
            }
        })
        this.bundleGroupedSetSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.addEventListener('click', this.groupedSetSelectorClick.bind(this))
            })
            if(selector.dataset.mandatory == 'true') {
                // selector.querySelector('.option-selector__variant').click()
            }
        })
        this.bundleSetSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.addEventListener('click', this.setSelectorClick.bind(this))
            })
            if(selector.dataset.mandatory == 'true') {
                // selector.querySelector('.option-selector__variant').click()
            }
        })
        setTimeout(()=>{
            this.minPrice = this.button.querySelector('.product-buy-options__price').innerHTML
            this.minBasePrice = parseFloat(this.minPrice.replace(/[^\d]/, ''))
        },300)
        // this.querySelector('.js-addToBag').addEventListener('click', (event)=>{
        //     event.preventDefault()
        //     event.stopPropagation()
        //     console.log('AAA')
        // })
        this.form.addEventListener('submit', this.formSubmit.bind(this))
        this.handlePreorder()
    }

    formSubmit(event) {
        event.preventDefault()
        // console.log('form submitted')
        // return false;
        const config = {
            method: 'POST',
            headers: {
                Accept: `application/json`,
                'X-Requested-With': 'XMLHttpRequest'
            },
        }

        const type = this.getAttribute('type')

        const timestamp = Date.now()
        const formData = new FormData();
        formData.append('sections', 'cart-drawer-section')
        let index = 0

        let bundle_variant = ''
        let bundle_label = this.getAttribute('bundle-label')
        let preorder_label = this.querySelector('.preorder-description') ? this.querySelector('.preorder-description').innerText : ''

        if(type == 'grouped-set') {
            
            const option = this.querySelector('.bundle-grouped-set-selector')
            if(option) {
                const vids = option.dataset.variantIds.split(',')
                console.log(option.dataset.variantIds)
                console.log(vids)
                vids.forEach((vid, ind)=>{
                    index = ind
                    if(index == 0) {
                        bundle_variant = vid
                    }
                    formData.append(`items[${index}][id]`, vid)
                    formData.append(`items[${index}][quantity]`, 1)
                    formData.append(`items[${index}][properties][_bundle_timestamp]`, timestamp)
                    formData.append(`items[${index}][properties][_bundle_variant]`, bundle_variant)
                    formData.append(`items[${index}][properties][_bundle_label]`, bundle_label)
                    if(preorder_label != '' && index == 0) {
                        formData.append(`items[${index}][properties][_bundle_preorder]`, preorder_label)
                    }
                })
            }

        } else if(type == 'set') {
            
            this.querySelectorAll('.js-productVariant').forEach((input, ind)=>{
                index = ind
                if(index == 0) {
                    bundle_variant = input.value
                }
                formData.append(`items[${index}][id]`, input.value)
                formData.append(`items[${index}][quantity]`, 1)
                formData.append(`items[${index}][properties][_bundle_timestamp]`, timestamp)
                formData.append(`items[${index}][properties][_bundle_variant]`, bundle_variant)
                if(preorder_label != '' && index == 0) {
                    formData.append(`items[${index}][properties][_bundle_preorder]`, preorder_label)
                }
            })
            const option = this.querySelector('.bundle-set-selector')
            if(option) {
                index++;
                if(!bundle_variant) {
                    bundle_variant = option.dataset.variantId
                }
                formData.append(`items[${index}][id]`, option.dataset.variantId)
                formData.append(`items[${index}][quantity]`, 1)
                formData.append(`items[${index}][properties][_bundle_timestamp]`, timestamp)
                formData.append(`items[${index}][properties][_bundle_variant]`, bundle_variant)
                if(preorder_label != '') {
                    formData.append(`items[${index}][properties][_bundle_preorder]`, preorder_label)
                }
            }
        } else if(type == 'bundle') {
            
            bundle_variant = this.idElement.value
            
            formData.append(`items[${index}][id]`, this.idElement.value)
            formData.append(`items[${index}][quantity]`, 1)
            formData.append(`items[${index}][properties][_bundle_variant]`, bundle_variant)
            formData.append(`items[${index}][properties][_bundle_timestamp]`, timestamp)

            if(preorder_label != '') {
                formData.append(`items[${index}][properties][_bundle_preorder]`, preorder_label)
            }
        
        } else if(type == 'same-as') {
            
            // bundle_variant = this.idElement.value
            
            // formData.append(`items[${index}][id]`, this.idElement.value)
            // formData.append(`items[${index}][quantity]`, 1)
            // formData.append(`items[${index}][properties][_bundle_variant]`, bundle_variant)
            // formData.append(`items[${index}][properties][_bundle_timestamp]`, timestamp)
            // formData.append(`items[${index}][properties][_bundle_label]`, bundle_label)
            // formData.append(`items[${index}][properties][_bundle_img]`, this.idElement.dataset.bundleImg)

            const qty = this.qtyElement ? this.qtyElement.value : 1
            formData.append(`items[${index}][id]`, this.idElement.value)
            formData.append(`items[${index}][quantity]`, qty)
            if(preorder_label != '') {
                formData.append(`items[${index}][properties][Preorder]`, preorder_label)
            }
            
        } else if(type == 'fixed-set') {
            
            const qty = this.qtyElement ? this.qtyElement.value : 1
            formData.append(`items[${index}][id]`, this.idElement.value)
            formData.append(`items[${index}][quantity]`, qty)
            if(preorder_label != '') {
                formData.append(`items[${index}][properties][Preorder]`, preorder_label)
            }

        } else if(type == 'variant-set') {
            
            bundle_variant = this.idElement.value
            const qty = this.qtyElement ? this.qtyElement.value : 1
            formData.append(`items[${index}][id]`, this.idElement.value)
            formData.append(`items[${index}][quantity]`, qty)

            const option = this.querySelector('.variant-set-selector')
            if(option) {
                if(option.dataset.setIds.length > 0) {
                    
                    formData.append(`items[${index}][properties][_bundle_timestamp]`, timestamp)
                    formData.append(`items[${index}][properties][_bundle_items]`, option.dataset.setIds)
                    
                }
            }
            if(preorder_label != '') {
                formData.append(`items[${index}][properties][Preorder]`, preorder_label)
            }

        } else if(type == 'variant-fixed-set') {
            
            const qty = this.qtyElement ? this.qtyElement.value : 1
            formData.append(`items[${index}][id]`, this.idElement.value)
            formData.append(`items[${index}][quantity]`, qty)
            if(preorder_label != '') {
                formData.append(`items[${index}][properties][Preorder]`, preorder_label)
            }

        }

        const optionsCount = this.optionsCount()

        this.bundleOptionSelectors.forEach((selector)=>{
            const optionIndex = selector.dataset.index
            if(this.options.hasOwnProperty(optionIndex)) {
                this.options[optionIndex].forEach((option, key)=>{
                    index++
                    formData.append(`items[${index}][id]`, option.variantId)
                    formData.append(`items[${index}][quantity]`, 1)
                    formData.append(`items[${index}][properties][_bundle_timestamp]`, timestamp)
                    formData.append(`items[${index}][properties][_bundle_variant]`, bundle_variant)
                    formData.append(`items[${index}][properties][_bundle_label]`, bundle_label)
                    formData.append(`items[${index}][properties][_bundle_option]`, true)
                    if(preorder_label != '') {
                        formData.append(`items[${index}][properties][_bundle_preorder]`, preorder_label)
                    }
                })
            }
        })
        
        this.buyOptions.querySelector('.error-bundle')?.remove()

        if(this.hasAttribute('min-options') && (parseInt(this.getAttribute('min-options')) > optionsCount)) {
            this.buyOptions.querySelector('.error-bundle')?.remove()
            const div = document.createElement('div')
            div.classList.add('error-bundle')
            if(parseInt(this.getAttribute('min-options')) > 1) {
                div.innerText = window.themeLabels.errorMinOptionsPlural.replace(/{{\s*min\s*}}/, this.getAttribute('min-options'))
            } else {
                div.innerText = window.themeLabels.errorMinOptionsSingular.replace(/{{\s*min\s*}}/, this.getAttribute('min-options'))
            }
            this.buyOptions.prepend(div)
            return;
        }
        if(this.hasAttribute('max-options') && (parseInt(this.getAttribute('max-options')) > 0) && (parseInt(this.getAttribute('max-options')) < optionsCount)) {
            this.buyOptions.querySelector('.error-bundle')?.remove()
            const div = document.createElement('div')
            div.classList.add('error-bundle')
            if(parseInt(this.getAttribute('max-options')) > 1) {
                div.innerText = window.themeLabels.errorMaxOptionsPlural.replace(/{{\s*max\s*}}/, this.getAttribute('max-options'))
            } else {
                div.innerText = window.themeLabels.errorMaxOptionsSingular.replace(/{{\s*max\s*}}/, this.getAttribute('max-options'))
            }
            this.buyOptions.prepend(div)
            return;
        }
        
        config.body = formData;
        // console.log(formData)
        // return
        
        const response = fetch('/cart/add.js', config)
        .then((response) => response.json())
        .then(response => {
            // console.log(response)
            const cart_section = response.sections['cart-drawer-section']
            // console.log(cart_section)
            const html = new DOMParser().parseFromString(cart_section, 'text/html');
            document.querySelector('#shopify-section-cart-drawer-section .cart-drawer__content').innerHTML = html.querySelector('.cart-drawer__content').innerHTML
            document.querySelector('.js-cartCount').innerHTML = html.querySelector('#cart-drawer-items').innerText.replace(/[^\d]*/g,'')
            document.querySelector('.js-cartToggle').click()
            // cartModel.fetch()
        });

    }

    groupedSetSelectorClick(event) {

        const value = event.currentTarget.dataset.value
        const variantIds = event.currentTarget.dataset.variantIds
        const basePrice = event.currentTarget.dataset.basePrice
        const price = event.currentTarget.dataset.price
        const available = JSON.parse(event.currentTarget.dataset.available)

        this.setAttribute('bundle-label', value)
        this.productName.innerHTML = value
        if(event.currentTarget.dataset.image) {
            document.querySelector('.product-details-top__image__wrapper img').setAttribute('src', event.currentTarget.dataset.image)
        }
        event.currentTarget.closest('.bundle-grouped-set-selector').dataset.variantIds = variantIds
        event.currentTarget.closest('.bundle-grouped-set-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value}`

        if(available) {
            this.button.classList.add('js-addToBag')
            this.button.classList.remove('js-waitlist')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.addToCart
            this.button.removeAttribute('disabled')
        } else {
            this.button.classList.remove('js-addToBag')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.soldOut
            this.button.setAttribute('disabled', true)
        }
        // if(price < this.minPrice) {
        //     price = this.minPrice
        //     basePrice = this.minBasePrice
        // }
        this.button.querySelector('.product-buy-options__price').innerHTML = price
        this.button.querySelector('.product-buy-options__price').dataset.basePrice = basePrice
        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            priceEl.innerHTML = price;
        })
        this.bundleGroupedSetSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.classList.remove('option-selector__variant--active')
            })
        })
        event.currentTarget.classList.add('option-selector__variant--active')
        this.optionSelectorUpdate()
        this.handlePreorder()
    }
    
    setSelectorClick(event) {
        const value = event.currentTarget.dataset.value
        const variantId = event.currentTarget.dataset.variantId
        const available = event.currentTarget.dataset.available
        const price = event.currentTarget.dataset.price
        const basePrice = event.currentTarget.dataset.basePrice
        event.currentTarget.closest('.bundle-set-selector').dataset.variantId = variantId
        event.currentTarget.closest('.bundle-set-selector').dataset.available = available
        let img = event.currentTarget.querySelector('img')
        if(img) {
            const image = `<img src="${img.src}" height="26" width="26" style="vertical-align:middle">`
            event.currentTarget.closest('.bundle-set-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value} ${image}`
        } else {
            event.currentTarget.closest('.bundle-set-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value}`
        }
        const swatch = event.currentTarget.querySelector('.option-selector__swatch')
        // console.log(swatch)
        if(swatch && this.productSelectorToggleSwatch) {
            this.productSelectorToggleSwatch.style.background = swatch.style.background;
        }
        const groupProductId = typeof event.currentTarget.dataset.groupProductId != 'undefined' ? event.currentTarget.dataset.groupProductId : null
        // console.log(`GI: ${groupProductId}`)
        if(groupProductId) {
            this.switchGallery(groupProductId)
        }
        this.button.querySelector('.product-buy-options__price').innerHTML = price
        this.button.querySelector('.product-buy-options__price').dataset.basePrice = basePrice
        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            priceEl.innerHTML = price;
        })
        this.bundleSetSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.classList.remove('option-selector__variant--active')
            })
        })
        event.currentTarget.classList.add('option-selector__variant--active')
        this.optionSelectorUpdate()
        this.handlePreorder()
    }

    groupSelectorClick(event) {
        const url = event.currentTarget.dataset.url
        const value = event.currentTarget.dataset.value
        let img = event.currentTarget.querySelector('img')
        if(img) {
            const image = `<img src="${img.src}" height="26" width="26" style="vertical-align:middle">`
            event.currentTarget.closest('.bundle-group-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value} ${image}`
        } else {
            event.currentTarget.closest('.bundle-group-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value}`
        }
        const swatch = event.currentTarget.querySelector('.option-selector__swatch')
        // console.log(swatch)
        if(swatch && this.productSelectorToggleSwatch) {
            this.productSelectorToggleSwatch.style.background = swatch.style.background;
        }
        location.href = url
    }

    optionSelectorRemoveClick(event) {
        event.stopPropagation();
        let done = false
        const variantId = event.currentTarget.dataset.variantId
        const index = event.currentTarget.closest('.bundle-option-selector').dataset.index
        const valueSelector = event.currentTarget.closest('.option-selector__variant')
        if(this.options.hasOwnProperty(index)) {
            this.options[index].forEach((option, key)=>{
                if(done) {
                    return
                }
                if(option.variantId == variantId) {
                    this.options[index].splice(key, 1)
                    done = true
                    valueSelector.dataset.qty = parseInt(valueSelector.dataset.qty) - 1
                    if(valueSelector.dataset.qty <= 0) {
                        valueSelector.classList.remove('active')
                    }
                }
            })
            if(this.options[index].length <= 0) {
                delete this.options[index]
            }
        }
        this.buyOptions.querySelector('.error-bundle')?.remove()
        this.optionSelectorUpdate()
        this.handlePreorder()
    }

    optionSelectorClick(event) {

        event.preventDefault()
        event.stopPropagation()
        const variantId = event.currentTarget.dataset.variantId
        const index = event.currentTarget.closest('.bundle-option-selector').dataset.index
        if(!this.options.hasOwnProperty(index)) {
            this.options[index] = []
        }
        if(variantId) {
            const price = event.currentTarget.dataset.price
            const value = event.currentTarget.dataset.value
            const formatted_price = event.currentTarget.dataset.formattedPrice
            const img = event.currentTarget.querySelector('img')
            const image = img ? `<img src="${img.src}" height="46" width="46">` : null
            this.options[index].push({
                variantId: variantId,
                value: value,
                price: price,
                formattedPrice : formatted_price,
                image: image
            })
            /*
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-variant-id', variantId)
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-price', price)
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-active', 'true')
            event.currentTarget.closest('.bundle-option-selector').querySelector('.price').innerHTML = `(+${formatted_price})`
            let img = event.currentTarget.querySelector('img')
            if(img) {
                const image = `<img src="${img.src}" height="46" width="46">`
                event.currentTarget.closest('.bundle-option-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value} ${image}`
            } else {
                event.currentTarget.closest('.bundle-option-selector').querySelector('.option-selector__toggle__value').innerHTML = `${value}`
            }
            event.currentTarget.closest('.bundle-option-selector').querySelectorAll('.option-selector__variant').forEach((selector)=>{
                if(this.options.includes(selector.dataset.variantId)) {
                    selector.classList.add('active')
                } else {
                    selector.classList.remove('active')
                }
            })
            */
        } else {
            /*
            // No clear link
            event.currentTarget.closest('.bundle-option-selector').removeAttribute('data-variant-id')
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-price', 0)
            event.currentTarget.closest('.bundle-option-selector').setAttribute('data-active', 'false')
            event.currentTarget.closest('.bundle-option-selector').querySelector('.option-selector__toggle__value').innerHTML = 'Please select'
            event.currentTarget.closest('.bundle-option-selector').querySelector('.price').innerHTML = ''
            event.currentTarget.closest('.bundle-option-selector').querySelectorAll('.option-selector__variant').forEach((selector)=>{
                selector.classList.remove('active')
            })
            */
        }

        this.optionSelectorUpdate()

        const optionsCount = this.optionsCount()

        this.buyOptions.querySelector('.error-bundle')?.remove()

        if(this.hasAttribute('max-options') && (parseInt(this.getAttribute('max-options')) > 0) && (parseInt(this.getAttribute('max-options')) < optionsCount)) {
            this.buyOptions.querySelector('.error-bundle')?.remove()
            const div = document.createElement('div')
            div.classList.add('error-bundle')
            if(parseInt(this.getAttribute('max-options')) > 1) {
                div.innerText = window.themeLabels.errorMaxOptionsPlural.replace(/{{\s*max\s*}}/, this.getAttribute('max-options'))
            } else {
                div.innerText = window.themeLabels.errorMaxOptionsSingular.replace(/{{\s*max\s*}}/, this.getAttribute('max-options'))
            }
            this.buyOptions.prepend(div)
        }
        this.handlePreorder()
    }

    optionsCount() {
        let count = 0
        for (const key in this.options) {
            if (this.options.hasOwnProperty(key)) {
                count+= this.options[key].length
            }
        }
        // console.log(`C: ${count}`)
        return count
    }

    optionSelectorUpdate() {
        document.querySelectorAll('.product-details-top__images .product-details-top__image--small, .product-details-top__images .product-details-top__images__spacer')?.forEach((item)=>{
            item.remove()
        })

        let firstImage = true
        let productPrice = parseFloat(this.querySelector('.product-buy-options__price').dataset.basePrice)
        let hasOptionsSelected = false

        this.bundleOptionSelectors.forEach((selector)=>{
            const index = selector.dataset.index
            selector.querySelectorAll('.option-selector__variant').forEach((optionLi)=>{
                optionLi.dataset.qty = 0
            })
            if(this.options.hasOwnProperty(index)) {
                let total = 0,
                    values = [],
                    images = [],
                    formattedPrice = ''
                
                this.options[index].forEach((option)=>{
                    total+= parseFloat(option.price)
                    values.push(option.value)
                    formattedPrice = option.formattedPrice
                    if(option.image) {
                        images.push(option.image)
                        this.addBundleOptionImage(selector, option, firstImage)
                        firstImage = false
                    }
                    const variantSelector = selector.querySelector(`.option-selector__variant[data-variant-id="${option.variantId}"]`)
                    variantSelector.classList.add('active')
                    variantSelector.dataset.qty = parseInt(variantSelector.dataset.qty) + 1
                })

                if(total > 0) {
                    productPrice+= total
                    total = formattedPrice.replace(/[\d.]+/, total)
                    selector.querySelector('.price').innerHTML = `(+${total})`
                } else {
                    selector.querySelector('.price').innerHTML = ``
                }

                // console.log(values)
                if(images.length > 0) {
                    selector.querySelector('.option-selector__toggle__value').innerHTML = `<span class="value-list">${values.join(', ')}</span> ${images.join('')}`
                } else {
                    selector.querySelector('.option-selector__toggle__value').innerHTML = `<span class="value-list">${values.join(', ')}</span>`
                }

            } else {
                // clear selector
                selector.removeAttribute('data-variant-id')
                selector.setAttribute('data-price', 0)
                selector.setAttribute('data-active', 'false')
                selector.querySelector('.option-selector__toggle__value').innerHTML = window.themeLabels.pleaseSelect
                selector.querySelector('.price').innerHTML = ''
                selector.querySelectorAll('.option-selector__variant').forEach((li)=>{
                    li.classList.remove('active')
                    li.dataset.qty = 0
                })
            }
        })

        if(this.optionsCount() == 0 && this.minCharmPrice > 0) {
            productPrice+= this.minCharmPrice
        }
        // if(productPrice < this.minBasePrice) {
        //     productPrice = this.minBasePrice
        // }

        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            const oldPriceString = priceEl.innerText;
    // eslint-disable-next-line no-param-reassign
            priceEl.innerHTML = oldPriceString.replace(/[\d.]+.*/, productPrice);
        })
    }

    addBundleOptionImage(selector, option, firstImage) {
        const variantId = option.variantId
        const variantSelect = selector.querySelector(`.option-selector__variant[data-variant-id="${variantId}"]`)

        if(firstImage) {
            const spacer = document.createElement('hr')
            spacer.classList.add('product-details-top__images__spacer')
            document.querySelector('.product-details-top__images').append(spacer)
        }

        const picture = document.createElement('picture')
        const source1 = document.createElement('source')
        source1.setAttribute('media', '(max-width: 1023px)')
        source1.setAttribute('srcset', variantSelect.dataset.image1)
        picture.append(source1)
        const source2 = document.createElement('source')
        source2.setAttribute('media', '(min-width: 1024px) and (max-width: 1280px)')
        source2.setAttribute('srcset', variantSelect.dataset.image2)
        picture.append(source2)
        const source3 = document.createElement('source')
        source3.setAttribute('media', '(min-width: 1281px) and (max-width: 1600px)')
        source3.setAttribute('srcset', variantSelect.dataset.image3)
        picture.append(source3)
        const source4 = document.createElement('source')
        source4.setAttribute('media', '(min-width: 1601px)')
        source4.setAttribute('srcset', variantSelect.dataset.image4)
        picture.append(source4)
        const img = document.createElement('img')
        img.setAttribute('src', variantSelect.dataset.image)
        picture.append(img)
        const div1 = document.createElement('div')
        div1.classList.add('product-details-top__image','product-details-top__image--small','js-componentDetailsImage')
        const div2 = document.createElement('div')
        div2.classList.add('product-details-top__image__wrapper')
        div1.append(div2)
        const remove = document.createElement('span')
        remove.classList.add('remove')
        remove.dataset.variantId = variantId
        remove.dataset.index = selector.dataset.index
        div2.append(picture)
        div2.append(remove)
        document.querySelector('.product-details-top__images').append(div1)

        remove.addEventListener('click', this.removeOptionClick.bind(this))
    }

    removeOptionClick(event) {
        const variantId = event.currentTarget.dataset.variantId
        const index = event.currentTarget.dataset.index
        this.bundleOptionSelectors.forEach((selector)=>{
            if(selector.dataset.index == index) {
                selector.querySelector(`.option-selector__variant[data-variant-id="${variantId}"] .remove`)?.click()
            }
        })
    }

    productSelectorClick(event) {
        // console.log(event.currentTarget)
        const productId = event.currentTarget.dataset.productId
        const variantId = event.currentTarget.dataset.variantId
        const value = event.currentTarget.dataset.value
        const swatch = event.currentTarget.querySelector('.option-selector__swatch')
        const price = event.currentTarget.dataset.price
        const basePrice = event.currentTarget.dataset.basePrice
        this.idElement.value = variantId
        this.productSelectorToggleValue.innerHTML = value
        if(swatch && this.productSelectorToggleSwatch) {
            this.productSelectorToggleSwatch.style.background = swatch.style.background;
        }
        this.switchGallery(productId)
        event.currentTarget.dataActive = true
        this.bundleProductSelector?.querySelectorAll('.option-selector__variant')?.forEach((selector)=>{
            if(selector == event.currentTarget) {
                selector.dataset.active = true
            } else {
                selector.dataset.active = false
            }
        })
        this.button.querySelector('.product-buy-options__price').innerHTML = price
        this.button.querySelector('.product-buy-options__price').dataset.basePrice = basePrice
        this.optionSelectorUpdate()
        this.handlePreorder()
    }

    variantSetClick(event) {
        const variantId = event.currentTarget.dataset.variantId
        const setIds = event.currentTarget.dataset.setIds
        const value = event.currentTarget.dataset.value
        const basePrice = event.currentTarget.dataset.basePrice
        const price = event.currentTarget.dataset.price
        const available = JSON.parse(event.currentTarget.dataset.available)
        this.idElement.value = variantId
        this.productSelectorToggleValue.innerHTML = value
        event.currentTarget.closest('.variant-set-selector').dataset.setIds = setIds
        if(event.currentTarget.dataset.image) {
            this.productImagePicture.querySelectorAll('source')?.forEach((source, index) => {
                const key = index + 1
                // console.log(event.currentTarget.dataset[`image${key}`])
                source.setAttribute('srcset', event.currentTarget.dataset[`image${key}`])
            });
            const img = this.productImagePicture.querySelector('img')
            img.setAttribute('src', event.currentTarget.dataset.image)
            this.productImagePicture.querySelector('button')?.setAttribute('data-image', event.currentTarget.dataset.imageMaster)
        }
        if(available) {
            this.button.classList.add('js-addToBag')
            this.button.classList.remove('js-waitlist')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.addToCart
            this.button.removeAttribute('disabled')
        } else {
            this.button.classList.remove('js-addToBag')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.soldOut
            this.button.setAttribute('disabled', true)
        }
        // this.switchGallery(productId)
        this.productName.innerHTML = value
        this.button.querySelector('.product-buy-options__price').innerHTML = price
        this.button.querySelector('.product-buy-options__price').dataset.basePrice = basePrice
        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            priceEl.innerHTML = price;
        })

        this.variantSetSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.classList.remove('option-selector__variant--active')
            })
        })
        event.currentTarget.classList.add('option-selector__variant--active')

        this.handlePreorder()
    }

    variantFixedSetClick(event) {
        const variantId = event.currentTarget.dataset.variantId
        const value = event.currentTarget.dataset.value
        const basePrice = event.currentTarget.dataset.basePrice
        const price = event.currentTarget.dataset.price
        const available = JSON.parse(event.currentTarget.dataset.available)
        this.idElement.value = variantId
        this.productSelectorToggleValue.innerHTML = value
        if(event.currentTarget.dataset.image) {
            this.productImagePicture.querySelectorAll('source')?.forEach((source, index) => {
                const key = index + 1
                // console.log(event.currentTarget.dataset[`image${key}`])
                source.setAttribute('srcset', event.currentTarget.dataset[`image${key}`])
            });
            const img = this.productImagePicture.querySelector('img')
            img.setAttribute('src', event.currentTarget.dataset.image)
            this.productImagePicture.querySelector('button')?.setAttribute('data-image', event.currentTarget.dataset.imageMaster)
        }
        if(available) {
            this.button.classList.add('js-addToBag')
            this.button.classList.remove('js-waitlist')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.addToCart
            this.button.removeAttribute('disabled')
        } else {
            this.button.classList.remove('js-addToBag')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.soldOut
            this.button.setAttribute('disabled', true)
        }
        // this.switchGallery(productId)
        this.productName.innerHTML = value
        this.button.querySelector('.product-buy-options__price').innerHTML = price
        this.button.querySelector('.product-buy-options__price').dataset.basePrice = basePrice
        document.querySelectorAll('.js-productPrice').forEach((priceEl)=>{
            priceEl.innerHTML = price;
        })
        this.variantFixedSetSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant')?.forEach((variantSelector)=>{
                variantSelector.classList.remove('option-selector__variant--active')
            })
        })
        event.currentTarget.classList.add('option-selector__variant--active')

        this.handlePreorder()
    }

    switchGallery(productId) {
        const object = document.querySelector(`[type="application/json"]#gallery-json-${productId}`);
        if(!object) {
            return
        }
        const productData = JSON.parse(object.textContent);
        // console.log(productData)
        this.productGallery.innerHTML = ''
        productData.images.forEach((image, index)=>{
            if(index == 0) {
                this.productImagePicture.querySelectorAll('source,img')?.forEach(element => {
                    element.remove()
                });
                image.sources.forEach(data => {
                    const source = document.createElement('source')
                    source.setAttribute('media', data.media)
                    source.setAttribute('srcset', data.srcset)
                    this.productImagePicture.prepend(source)
                });
                const img = document.createElement('img')
                img.setAttribute('src', image.img)
                this.productImagePicture.prepend(img)
                this.productImagePicture.querySelector('button')?.setAttribute('data-image', image.master)
            } else {
                const div = document.createElement('div')
                div.dataset.noStates = true
                div.classList.add('product-gallery__image__wrapper','js-productImage','js-scroll')
                const picture = document.createElement('picture')
                image.sources.forEach(data => {
                    const source = document.createElement('source')
                    source.setAttribute('media', data.media)
                    source.setAttribute('srcset', data.srcset)
                    picture.append(source)
                });
                const img = document.createElement('img')
                img.setAttribute('src', image.img)
                picture.append(img)
                div.append(picture)

                const button = document.createElement('button')
                button.setAttribute('aria-controls', 'pdp-images-zoom')
                button.setAttribute('aria-expanded', 'false')
                button.setAttribute('data-image', image.master)
                button.classList.add('pdp-images__zoom-button','js-zoomOpen')
                const span = document.createElement('span')
                span.classList.add('visually-hidden')
                span.innerText = 'Zoom image'
                button.append(span)
                div.append(button)
                
                this.productGallery.append(div)
            }
        })
    }

    handlePreorder() {
        console.log('handle preorder')
        let preorder = ''
        this.button.querySelector('.preorder-description')?.remove()
        const type = this.getAttribute('type')
        let available = true

        if(type == 'bundle') {
            console.log(`bundle preorder`)
            const selector = this.bundleProductSelector?.querySelector('.option-selector__variant[data-active="true"]')
            preorder = typeof selector.dataset.preorder != 'undefined' ? selector.dataset.preorder : ''
            const availableVar = JSON.parse(selector.dataset.available)
            if(!availableVar) {
                available = false
            }
        }
        if(type == 'variant-fixed-set') {
            console.log(`vfs preorder`)
            this.querySelectorAll('.js-productVariant').forEach((input, ind)=>{
                const availableVar = JSON.parse(input.dataset.available)
                if(!availableVar) {
                    available = false
                }
                preorder = typeof input.dataset.preorder != 'undefined' ? input.dataset.preorder : preorder
            })
            this.variantFixedSetSelectors?.forEach((selector)=>{
                const item = selector.querySelector('.option-selector__variant.option-selector__variant--active')
                preorder = typeof item.dataset.preorder != 'undefined' ? item.dataset.preorder : ''
                const availableVar = JSON.parse(item.dataset.available)
                if(!availableVar) {
                    available = false
                }
            })
        }
        if(type == 'variant-set') {
            console.log(`vs preorder`)
            this.variantSetSelectors?.forEach((selector)=>{
                const item = selector.querySelector('.option-selector__variant.option-selector__variant--active')
                console.log(item)
                preorder = typeof item.dataset.preorder != 'undefined' ? item.dataset.preorder : ''
                const availableVar = JSON.parse(item.dataset.available)
                if(!availableVar) {
                    available = false
                }
            })
        }
        if(type == 'fixed-set') {
            console.log(`fs preorder`)
            preorder = typeof this.button.dataset.preorder != 'undefined' ? this.button.dataset.preorder : ''
                // const availableVar = JSON.parse(item.dataset.available)
                // if(!availableVar) {
                //     available = false
                // }
        }
        if(type == 'same-as') {
            preorder = typeof this.button.dataset.preorder != 'undefined' ? this.button.dataset.preorder : ''
        }
        if(type == 'set') {
            console.log(`set preorder`)
            this.querySelectorAll('.js-productVariant').forEach((input, ind)=>{
                const availableVar = JSON.parse(input.dataset.available)
                if(!availableVar) {
                    available = false
                }
                preorder = typeof input.dataset.preorder != 'undefined' ? input.dataset.preorder : preorder
            })
            const option = this.querySelector('.bundle-set-selector')
            if(option) {
                const availableVar = JSON.parse(option.dataset.available)
                if(!availableVar) {
                    available = false
                }
            }
            this.bundleSetSelectors?.forEach((selector)=>{
                const item = selector.querySelector('.option-selector__variant.option-selector__variant--active')
                preorder = typeof item.dataset.preorder != 'undefined' ? item.dataset.preorder : ''
            })
        }
        if(type == 'grouped-set') {
            this.bundleGroupedSetSelectors?.forEach((selector)=>{
                const item = selector.querySelector('.option-selector__variant.option-selector__variant--active')
                preorder = typeof item.dataset.preorder != 'undefined' ? item.dataset.preorder : ''
                const availableVar = JSON.parse(item.dataset.available)
                if(!availableVar) {
                    available = false
                }
                console.log(`Grouped set available: ${available}`)
            })
        }

        console.log(`BP2: ${preorder}`)
        this.bundleOptionSelectors?.forEach((selector)=>{
            selector.querySelectorAll('.option-selector__variant.active').forEach((li)=>{
                const availableOpt = JSON.parse(li.dataset.available)
                if(!availableOpt) {
                    available = false
                }
                if(typeof li.dataset.preorder != undefined) {
                    if(li.dataset.preorder > preorder) {
                        preorder = li.dataset.preorder
                    }
                }
            })
        })

        if(available) {
            this.button.classList.add('js-addToBag')
            this.button.classList.remove('js-waitlist')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.addToCart
            this.button.removeAttribute('disabled')
        } else {
            this.button.classList.remove('js-addToBag')
            this.button.querySelector('.button--add-to-bag').innerHTML = window.themeLabels.soldOut
            this.button.setAttribute('disabled', true)
            preorder = ''
        }

        if(preorder == '') {
            this.button.querySelector('.preorder-description')?.remove()
            // this.button.querySelector('.button--add-to-bag').innerText = window.themeLabels.addToCart
            return
        }
        const date = new Date(preorder)
        let dateLabel = `${date.getMonth() + 1}/${date.getDate()}`
        console.log(`PRO: ${preorder}`)
        console.log(date)
        const preorderLabel = document.createElement('div')
        preorderLabel.classList.add('preorder-description')
        preorderLabel.innerHTML = window.themeLabels.preorderDate.replace(/{{\s*date\s*}}/, dateLabel)
        this.button.querySelector('.button--add-to-bag').after(preorderLabel)
        this.button.querySelector('.button--add-to-bag').innerText = window.themeLabels.preorderLabel
    }
}

customElements.define("product-buy-options", ProductBuyOptions);